import { getLoginUser } from "../api/generated/wrappers/user";
import { getUsers } from "../api/generated/wrappers/user";
import { getUserAuthority, } from "../api/generated/wrappers/user";
import { getAuthoritys } from "../api/generated/wrappers/user";
import { getAllowedMenu } from "../api/generated/wrappers/user";
import { createQueryKeys } from "./create-query-keys";
const userQueryKeys = createQueryKeys("user", {
    all: (params) => ({
        queryKey: ["all", params],
        queryFn: async () => await getUsers(params),
    }),
    loginUser: () => ({
        queryKey: ["loginUser"],
        queryFn: getLoginUser,
    }),
    userAuthority: (params) => ({
        queryKey: ["userAuthority", params],
        queryFn: async () => await getUserAuthority(params),
    }),
    authoritys: () => ({
        queryKey: ["authoritys"],
        queryFn: getAuthoritys,
    }),
    allowedMenu: () => ({
        queryKey: ["allowedMenu"],
        queryFn: getAllowedMenu,
    }),
});
export default userQueryKeys;
